import clsx from 'clsx'

import LoadingBar from 'components/LoadingBar'

import s from './TopSearchLoader.module.css'

type Props = {
  isSelfRankingPages?: boolean
}

export const TopSearchLoader = ({ isSelfRankingPages = false }: Props) => {
  return (
    <div className={s.loading}>
      <span
        className={clsx(s.positionIndicator, {
          [s.yourPagesPositionIndicator]: isSelfRankingPages,
        })}
      >
        #
      </span>
      <LoadingBar width={260} borderRadius={4} />
      <LoadingBar height={28} width={28} borderRadius={50} />
    </div>
  )
}
